// Comprehensive UK Postcode Area Mapping

// ignore duplicate keys linter error
/* eslint-disable */
export const comprehensivePostcodeMapping = {
  // London Areas (13 areas)
  E: 'E',
  EC: 'EC',
  N: 'N',
  NW: 'NW',
  W: 'W',
  SE: 'SE',
  SW: 'SW',
  TW: 'TW',
  WC: 'WC',
  BR: 'BR',
  RM: 'RM',
  HA: 'HA',
  CR: 'CR',
  IG: 'IG',
  SM: 'SM',

  // South East England (15 areas)
  KT: 'Kingston upon Thames',
  OX: 'Oxford',
  RH: 'Redhill',
  GU: 'Guildford',
  PO: 'Portsmouth',
  RG: 'Reading',
  SL: 'Slough',
  SO: 'Southampton',
  BN: 'Brighton',
  TN: 'Tonbridge',
  CT: 'Canterbury',
  DA: 'Dartford',
  ME: 'Medway',
  CM: 'Chelmsford',
  SS: 'Southend-on-Sea',
  IP: 'Ipswich',
  CO: 'Colchester',

  // South West England
  BH: 'Bournemouth',
  BA: 'Bath',
  BS: 'Bristol',
  DT: 'Dorchester',
  EX: 'Exeter',
  GL: 'Gloucester',
  PL: 'Plymouth',
  SN: 'Swindon',
  SP: 'Salisbury',
  TA: 'Taunton',
  TQ: 'Torquay',
  TR: 'Truro',

  // East of England
  AL: 'St Albans',
  CB: 'Cambridge',
  EN: 'Enfield',
  HP: 'Hemel Hempstead',
  LU: 'Luton',
  MK: 'Milton Keynes',
  NN: 'Northampton',
  NR: 'Norwich',
  PE: 'Peterborough',
  SG: 'Stevenage',
  WD: 'Watford',

  // West Midlands
  B: 'Birmingham',
  CV: 'Coventry',
  DE: 'Derby',
  DY: 'Dudley',
  HR: 'Hereford',
  LE: 'Leicester',
  NG: 'Nottingham',
  ST: 'Stoke-on-Trent',
  TF: 'Telford',
  WS: 'Walsall',
  WV: 'Wolverhampton',

  // East Midlands
  DN: 'Doncaster',
  LN: 'Lincoln',
  S: 'Sheffield',

  // Yorkshire and the Humber
  BD: 'Bradford',
  HD: 'Huddersfield',
  HG: 'Harrogate',
  HU: 'Hull',
  HX: 'Halifax',
  LS: 'Leeds',
  WF: 'Wakefield',
  YO: 'York',

  // North West England
  BB: 'Blackburn',
  BL: 'Bolton',
  CA: 'Carlisle',
  CH: 'Chester',
  CW: 'Crewe',
  L: 'Liverpool',
  LA: 'Lancaster',
  M: 'Manchester',
  OL: 'Oldham',
  PR: 'Preston',
  SK: 'Stockport',
  WA: 'Warrington',
  WN: 'Wigan',

  // North East England
  DH: 'Durham',
  DL: 'Darlington',
  NE: 'Newcastle upon Tyne',
  SR: 'Sunderland',
  TS: 'Cleveland',

  // Scotland
  AB: 'Aberdeen',
  DD: 'Dundee',
  DG: 'Dumfries',
  EH: 'Edinburgh',
  FK: 'Falkirk',
  G: 'Glasgow',
  HS: 'Outer Hebrides',
  IV: 'Inverness',
  KA: 'Kilmarnock',
  KW: 'Kirkwall',
  KY: 'Kirkcaldy',
  ML: 'Motherwell',
  PA: 'Paisley',
  PH: 'Perth',
  TD: 'Galashiels',
  ZE: 'Shetland',

  // Wales
  CF: 'Cardiff',
  LD: 'Llandrindod Wells',
  LL: 'Llandudno',
  NP: 'Newport',
  SA: 'Swansea',
  SY: 'Shrewsbury',

  // Northern Ireland
  BT: 'Belfast',

  // Isle of Man
  IM: 'Isle of Man'
}

export const ieRoutingKeys = {
  // Dublin
  D01: [53.3498, -6.2603], D02: [53.3382, -6.2591], D03: [53.3659, -6.2495],
  D04: [53.3203, -6.2342], D05: [53.3894, -6.2713], D06: [53.3302, -6.2778],
  D6W: [53.3220, -6.2890], D07: [53.3587, -6.2826], D08: [53.3378, -6.2968],
  D09: [53.3872, -6.2422], D10: [53.3668, -6.3215], D11: [53.3891, -6.2874],
  D12: [53.3193, -6.3281], D13: [53.3978, -6.1893], D14: [53.3078, -6.2561],
  D15: [53.3877, -6.3912], D16: [53.2893, -6.2614], D17: [53.4012, -6.1543],
  D18: [53.2693, -6.2114], D20: [53.3478, -6.3987], D22: [53.3178, -6.3814],
  D24: [53.2878, -6.3714],
  // County Dublin / Surrounding
  A41: [53.8006, -6.4089], A42: [53.7889, -6.4111], A45: [53.7456, -6.4534],
  A63: [53.2089, -6.1111], A67: [53.2456, -6.0534], A75: [53.2756, -6.0834],
  A82: [53.5456, -6.6834], A83: [53.2056, -6.0534], A84: [53.1956, -6.0634],
  A85: [53.1856, -6.0734], A86: [53.1756, -6.0834], A91: [53.9978, -6.4011],
  A92: [53.7209, -6.3511], A94: [53.2789, -6.1311], A96: [53.2589, -6.1511],
  A98: [53.1889, -6.0711],
  // Kildare
  W23: [53.2314, -6.4934], W34: [53.1814, -6.5434], W91: [53.1614, -6.9134],
  R14: [53.2914, -6.6634], R51: [53.0814, -6.7434], R56: [53.0314, -6.9934],
  // Meath
  C15: [53.5256, -6.7934],
  // Cork
  T12: [51.8969, -8.4863], T23: [51.9169, -8.5063], T34: [51.9369, -8.5263],
  T45: [51.8569, -8.4063], T56: [51.8769, -8.4463],
  P14: [51.9569, -8.6263], P17: [51.9269, -8.5763], P24: [51.8469, -8.2963],
  P25: [51.8169, -8.2663], P31: [51.7869, -8.2363], P32: [51.7569, -8.2063],
  P36: [51.7269, -8.1763], P43: [51.6969, -8.1463], P47: [51.6669, -8.1163],
  P51: [51.6369, -8.0863], P61: [51.6069, -8.0563], P67: [51.5769, -8.0263],
  P72: [51.8269, -8.5463], P75: [51.8569, -8.6463], P81: [51.8869, -8.7463],
  P85: [51.9169, -8.8463],
  // Kerry
  V14: [52.2663, -9.6961], V15: [52.2363, -9.7261], V23: [52.0663, -9.5261],
  V31: [52.0363, -9.4961], V35: [52.0063, -9.4661], V42: [51.9763, -9.4361],
  V92: [52.0563, -10.0261], V93: [52.0863, -9.9961], V94: [52.6663, -8.6261],
  V95: [52.8463, -8.9861],
  // Galway
  H54: [53.5072, -8.8500], H62: [53.4772, -8.8200], H65: [53.4472, -8.7900],
  H71: [53.4172, -8.7600], H91: [53.2772, -9.0500],
  // Mayo
  F12: [53.7634, -9.2973], F23: [53.8034, -9.3373], F26: [53.8334, -9.3673],
  F28: [53.8634, -9.3973], F31: [53.8934, -9.4273], F32: [53.9234, -9.4573],
  F35: [53.9534, -9.4873], F45: [53.9834, -9.5173],
  // Sligo
  F52: [54.0634, -8.6273], F56: [54.0934, -8.6573], F91: [54.2767, -8.4761],
  // Donegal
  F92: [54.6534, -8.1173], F93: [54.9534, -7.7173], F94: [55.0534, -7.6173],
  // Roscommon
  F42: [53.6334, -8.1873],
  // Longford
  N39: [53.7272, -7.7933],
  // Westmeath
  N37: [53.5272, -7.3433], N91: [53.4372, -7.4933],
  // Offaly
  R35: [53.2372, -7.4933], R42: [53.1072, -7.9033],
  // Laois
  R32: [53.0372, -7.5533], R93: [52.8672, -7.2533],
  // Tipperary
  E21: [52.8072, -7.8233], E25: [52.6772, -7.8533], E32: [52.4772, -8.1633],
  E34: [52.4072, -7.9033], E41: [52.3472, -7.6933], E45: [52.2772, -7.8433],
  E53: [52.6572, -8.0233], E91: [52.5172, -7.8233],
  // Kilkenny
  R95: [52.6541, -7.2448],
  // Waterford
  X35: [52.2593, -7.1101], X42: [52.1593, -7.1501], X91: [52.2593, -7.1101],
  // Wexford
  Y21: [52.4667, -6.5667], Y25: [52.3367, -6.4667], Y34: [52.2467, -6.3667],
  Y35: [52.3367, -6.5667],
  // Carlow
  R93: [52.8408, -6.9261],
  // Cavan
  H12: [53.9908, -7.3611],
  // Monaghan
  H18: [54.2508, -6.9711],
  // Leitrim
  N41: [54.1108, -8.0811]
}

// Clean regional groupings without duplicate keys
export const postcodeRegions = {
  LONDON: ['E', 'EC', 'N', 'NW', 'W', 'SE', 'SW', 'TW', 'WC', 'BR', 'RM', 'HA', 'CR', 'IG', 'SM'],

  SOUTH_EAST: ['KT', 'OX', 'RH', 'GU', 'PO', 'RG', 'SL', 'SO', 'BN', 'TN', 'CT', 'DA', 'ME', 'CM', 'SS', 'IP', 'CO'],

  SOUTH_WEST: ['BH', 'BA', 'BS', 'DT', 'EX', 'GL', 'PL', 'SN', 'SP', 'TA', 'TQ', 'TR'],

  EAST_OF_ENGLAND: ['AL', 'CB', 'EN', 'HP', 'LU', 'MK', 'NN', 'NR', 'SG', 'PE', 'WD'],

  MIDLANDS: ['B', 'CV', 'DY', 'ST', 'TF', 'WS', 'WV', 'LN', 'DE', 'LE', 'NG'],

  YORKSHIRE_HUMBER: ['BD', 'HG', 'HU', 'HX', 'LS', 'WF', 'YO', 'DN', 'S', 'HD'],

  NORTH_WEST: ['BB', 'BL', 'CW', 'L', 'LA', 'M', 'OL', 'PR', 'SK', 'WA', 'WN', 'CA', 'CH'],

  NORTH_EAST: ['DH', 'DL', 'NE', 'SR', 'TS'],

  SCOTLAND: ['AB', 'DD', 'DG', 'EH', 'FK', 'G', 'HS', 'IV', 'KA', 'KW', 'KY', 'ML', 'PA', 'PH', 'TD', 'ZE'],

  WALES: ['CF', 'LD', 'LL', 'NP', 'SA', 'SY', 'HR'],

  NORTHERN_IRELAND: ['BT'],

  ISLE_OF_MAN: ['IM']
}
